const ABProcessTaskSubProcessCore = require("../../../core/process/tasks/ABProcessTaskSubProcessCore");
module.exports = class ABProcessTaskSubProcess extends (
   ABProcessTaskSubProcessCore
) {};
